import { Loading } from "@/layouts/loading";
import { getVoidSales } from "@/routes/(pharma)/_layout/reports/void-sales/-data/api";
import { VoidSaleParams } from "@/routes/(pharma)/_layout/reports/void-sales/-data/model";
import { VoidSaleSchema } from "@/routes/(pharma)/_layout/reports/void-sales/-data/type";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/reports/void-sales/-components/component";

export const Route = createFileRoute("/(pharma)/_layout/reports/void-sales/")({
    component: Component,
    validateSearch: VoidSaleParams,
    loaderDeps: ({ search: { page, pageSize } }) => ({
        page,
        pageSize,
    }),
    loader: async (params): Promise<VoidSaleSchema[]> => {
        const response = await getVoidSales(
            params.deps.page - 1,
            params.deps.pageSize
        );
        return response;
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1,
});
